<template>
    <v-card class="pa-4 d-flex flex-column" height="90vh">
        <v-card-title class="d-flex align-center justify-center position-relative">
            <v-btn @click="emit('back')" icon variant="elevated" class="position-absolute" style="left: 0"
                color="primary" size="x-small">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h2 class="text-h5 font-weight-bold text-primary text-center w-100">
                Missions
            </h2>
        </v-card-title>

        <v-tabs v-model="tab" color="primary" align-tabs="center" class="mt-2">
            <v-tab value="finished" variant="plain">
                <v-icon start>mdi-album</v-icon>
                History
            </v-tab>
            <v-divider vertical class="mx-2" />
            <v-tab value="active" variant="plain">
                <v-icon start>mdi-access-point</v-icon>
                Actives
            </v-tab>
        </v-tabs>

        <v-divider class="my-2" />

        <div style="flex: 1; overflow-y: auto;">
            <v-window v-model="tab">
                <!-- FINISHED -->
                <v-window-item value="finished">
                    <template v-if="list.filter(m => m.active_mission === 0).length === 0">
                        <p class="text-center">There are no history missions.</p>
                    </template>
                    <v-virtual-scroll v-else :items="list.filter(m => m.active_mission === 0)" height="auto">
                        <template v-slot:default="{ item, index }">
                            <MissionElement :mission="item" :key="index" @add="emit('add', item)" />
                        </template>
                    </v-virtual-scroll>
                </v-window-item>

                <!-- ACTIVE -->
                <v-window-item value="active">
                    <template v-if="list.filter(m => m.active_mission === 1).length === 0">
                        <p class="text-center">There aren't any active missions.</p>
                    </template>
                    <v-virtual-scroll v-else :items="list.filter(m => m.active_mission === 1)" height="auto">
                        <template v-slot:default="{ item, index }">
                            <MissionElement :mission="item" :key="index" @add="emit('add', item)" />
                        </template>
                    </v-virtual-scroll>
                </v-window-item>
            </v-window>
        </div>
    </v-card>
</template>


<script setup>
import { ref } from 'vue';
import MissionElement from './MissionElement.vue';

defineProps(['list']);
const emit = defineEmits(['back', 'add']);
const tab = ref('finished');
</script>
